export default "__VITE_ASSET__CuNR7dzv__"